// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:940px){.entryForm[data-v-727611dd]{grid-template-areas:\"location dateOfBirth gender button\";grid-template-columns:280px 150px minmax(130px,auto) 1fr}.entryForm-gender[data-v-727611dd] .gender-element{justify-content:flex-start}.entryForm-gender[data-v-727611dd] .gender-element .gender-item__text{display:initial}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
